import { Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material';
import { Button } from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../../styles/color-tokens';

export function ChangeManagerOwnerDialog({
  open,
  onClose,
  onConfirm,
  hasActiveAgreements,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  hasActiveAgreements: boolean;
}) {
  const { t: tCompanies } = useTranslation('companies');
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ '& .MuiDialog-paper': { backgroundColor: colors.background.surface.base, color: colors.text.primary } }}
    >
      <DialogTitle>{tCompanies('dialog.changeOwnerManager.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText color={colors.text.primary}>
          {tCompanies(
            hasActiveAgreements ? 'dialog.changeOwnerManager.notAllowed' : 'dialog.changeOwnerManager.warning',
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary-dark" onClick={onClose}>
          {tCompanies('dialog.changeOwnerManager.cancel')}
        </Button>
        {!hasActiveAgreements && (
          <Button color="primary-dark" onClick={onConfirm}>
            {tCompanies('dialog.changeOwnerManager.confirm')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
